import React, { useState } from "react";
import styled from "styled-components";

const SidebarContainer = styled.div`
  background-color: white;
  padding: 20px;
  padding-top: 35%;
  padding-bottom: 5px;
  overflow-x: auto;
  height: 80vh;
  padding-bottom: 220px;
`;

const SidebarList = styled.ul`
  list-style: none;
  padding: 5px;
  padding-left: 20px;
`;

const SidebarListItem = styled.li<{ selected: boolean }>`
  margin-bottom: 15px;
  cursor: pointer;
  color: ${({ selected }) => (selected ? "#00FF00" : "#5E5E5E")};
  &:hover {
    color: #00ff00;
  }
  @media (max-width: 1100px) {
    margin-bottom: 10px;
  }
`;

interface SidebarProps {
  headings: string[];
  scrollToSection: (index: number) => void;
}

const Sidebar: React.FC<SidebarProps> = ({ headings, scrollToSection }) => {
  const [selectedHeading, setSelectedHeading] = useState<number | null>(null);

  const handleHeadingClick = (index: number) => {
    setSelectedHeading(index);
    scrollToSection(index);
  };

  return (
    <SidebarContainer>
      <SidebarList>
        {headings.map((heading, index) => (
          <SidebarListItem
            key={index}
            selected={selectedHeading === index}
            onClick={() => handleHeadingClick(index)}
          >
            {heading}
          </SidebarListItem>
        ))}
      </SidebarList>
    </SidebarContainer>
  );
};

export default Sidebar;
